<template>
    <footer class="app-footer">
        <div class="app-footer__inner">
            <span class="app-footer__copy">Creditor Portal powered by FORTH Pay</span>
            <a
                target="_blank"
                href="https://status.forthcrm.com/"
                class="app-footer__status"
                aria-label="System Status"
            >System Status</a>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
.app-footer {
    position: relative;
    height: 73px;

    &__inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        border-top: $footer-border;
    }

    &__copy,
    &__status {
        font-family: $font-family-archivo;
        font-size: 12px;
        font-weight: 300;
        line-height: 13px;
        color: rgba($black-color, 0.75);
    }

    &__status {
        text-decoration: underline;
        text-align: right;

        &:hover {
            color: $black-color;
        }
    }
}
</style>
